var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnYin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(607.877 106.416)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-607.877 -106.417)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(607.877 106.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(607.877 106.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M621.317,139.638a.3.3,0,0,1-.17-.538,4.964,4.964,0,0,0,1.965-4.123,3.778,3.778,0,0,0-2.706,2.16.3.3,0,1,1-.573-.147,4.375,4.375,0,0,1,3.513-2.655.3.3,0,0,1,.332.234,5.6,5.6,0,0,1-2.191,5.015A.293.293,0,0,1,621.317,139.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.192,141.122a.3.3,0,0,1-.054-.586,5.639,5.639,0,0,0,2.071-1.522c.121-.116.239-.23.354-.338-.256-.019-.51-.058-.77-.1-.238-.036-.485-.074-.753-.1a3.534,3.534,0,0,0-2.61,1.157,4.664,4.664,0,0,1-.433.353.3.3,0,1,1-.327-.493,4.413,4.413,0,0,0,.372-.3,4.022,4.022,0,0,1,3.054-1.3c.28.027.538.066.786.1a4.6,4.6,0,0,0,1.475.066.295.295,0,0,1,.214.536,8.8,8.8,0,0,0-.951.844,5.8,5.8,0,0,1-2.373,1.677A.25.25,0,0,1,623.192,141.122Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.74,139.3a.295.295,0,0,1-.159-.543c.424-.273.486-.939.158-1.7a3.2,3.2,0,0,0-1-1.176,3.232,3.232,0,0,1-.418.894,2.269,2.269,0,0,0-.4.976.289.289,0,0,1-.324.264.3.3,0,0,1-.264-.324,2.819,2.819,0,0,1,.478-1.222,2.067,2.067,0,0,0,.4-1.1.292.292,0,0,1,.148-.252.3.3,0,0,1,.293,0,4.234,4.234,0,0,1,1.628,1.711,1.872,1.872,0,0,1-.383,2.427A.3.3,0,0,1,619.74,139.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.005,
    height: 0.887,
    transform: "translate(619.865 120.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.395,
    height: 0.887,
    transform: "translate(623.571 122.59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.134,137.037H628.892a3.308,3.308,0,0,1-2.848-3.28V130.6a.444.444,0,0,1,.887,0v3.161a2.4,2.4,0,0,0,2.016,2.4l10.187-.005a.444.444,0,1,1,0,.888Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.887,
    height: 2.656,
    transform: "translate(630.571 120.378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.391,120.821a.443.443,0,0,1-.363-.7l3.571-5.091a.443.443,0,1,1,.726.509l-3.571,5.092A.442.442,0,0,1,634.391,120.821Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.015,120.821a.44.44,0,0,1-.419-.3l-1.461-4.262a.443.443,0,1,1,.839-.287l1.46,4.262a.444.444,0,0,1-.419.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.939,120.821a.443.443,0,0,1-.42-.3l-1.339-3.91a.443.443,0,0,1,.838-.286l1.34,3.909a.444.444,0,0,1-.419.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.877,142.036A15.619,15.619,0,1,1,643.5,126.417,15.638,15.638,0,0,1,627.877,142.036Zm0-30.351a14.731,14.731,0,1,0,14.731,14.732A14.748,14.748,0,0,0,627.877,111.685Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.887,
    height: 18.085,
    transform: "translate(615.245 117.375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.787,117.529a.444.444,0,0,1-.046-.885l18.253-1.936a.443.443,0,1,1,.093.881l-18.252,1.936A.39.39,0,0,1,619.787,117.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.076,133.913H629.71a.444.444,0,0,1,0-.888h11.366a.444.444,0,1,1,0,.888Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.864,129.663a4.809,4.809,0,1,1,4.65-4.807A4.735,4.735,0,0,1,619.864,129.663Zm0-8.665a3.862,3.862,0,1,0,3.7,3.858A3.787,3.787,0,0,0,619.864,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.864,132.843a2.218,2.218,0,0,1-2.181-2.247.444.444,0,0,1,.887,0,1.3,1.3,0,1,0,2.587,0,.443.443,0,0,1,.444-.443h15.092a1.939,1.939,0,0,0,1.859-1.618H625.678a1.847,1.847,0,0,1,0-3.691h11.015a2.853,2.853,0,0,1,2.784,2.8h3.484a.444.444,0,0,1,0,.888H639.45a2.834,2.834,0,0,1-2.757,2.5H622A2.2,2.2,0,0,1,619.864,132.843Zm5.814-7.112a.961.961,0,0,0,0,1.916h12.91a1.96,1.96,0,0,0-1.9-1.916Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.864,119.6a.443.443,0,0,1-.443-.443,1.558,1.558,0,1,0-3.113,0,.443.443,0,0,1-.887,0,2.445,2.445,0,1,1,4.887,0A.443.443,0,0,1,621.864,119.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnYin);
export default __webpack_public_path__ + "static/media/btn_yin.35ffcf6789abd26506785ddd20bd852d.svg";
export { ForwardRef as ReactComponent };